import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#666",
      "fill-rule": "nonzero",
      d: "M7 0a3.75 3.75 0 0 1 2.135 6.833 7 7 0 0 1 4.86 6.426L14 13.5a.5.5 0 0 1-.992.09L13 13.5a6 6 0 0 0-11.996-.225L1 13.5a.5.5 0 0 1-.992.09L0 13.5a7 7 0 0 1 4.864-6.668A3.75 3.75 0 0 1 7 0m0 1a2.75 2.75 0 1 0 0 5.5A2.75 2.75 0 0 0 7 1"
    }, null, -1)
  ])))
}
export default { render: render }